import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { DragableElementDecoratorViewModel } from "./dragableElementDecorator-viewModel"

export class DragableElementDecoratorView extends View<DragableElementDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-3AD188FA-8B88-4439-8310-4C46E184962A"
    }
    loadHtml(): string {
        let element = require('./dragableElementDecorator.html').default;
        let style = require('./dragableElementDecorator.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
}
